<template>
  <div>
    <section class="base-header-sec base-header-laen  laen">
      <div class="base-header__top-line laen"></div>
      <div class="container-fluid">
        <div class="   base-header__container ">
          <div class="  d-flex justify-content-center align-items-center">
            <h1 class="base-header__title text-center py-2">
              <!--                            <span class="base-header__icon icon-inbox mr-3"></span>-->
              Промена лозинке
            </h1>
          </div>
        </div>
      </div>
    </section>
    <div class="container-fluid base-container">
      <div class="base-box p-normal">
        <b-form @submit.stop.prevent="onSubmit">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group form-group-sm">
                <label class="form-label">Нова лозинка</label>
                <input type="password" v-model="$v.form.password.$model" :class="{ 'is-invalid form-group--error': $v.form.password.$error }"
                   class="form-control full-width" />
                <b-form-invalid-feedback class="error" v-if="!$v.form.password.required">Обавезно је попунити поље нова
                  лозинка.</b-form-invalid-feedback>
                <b-form-invalid-feedback class="error" v-if="!$v.form.password.minLength">Лозинка мора бити дужа од
                  {{ $v.form.password.$params.minLength.min }}
                  карактера.</b-form-invalid-feedback>
                  <b-form-invalid-feedback class="error" v-if="!$v.form.password.validCharacters">
                    Лозинка може садржати само абецедно писмо (a-z) и бројеве.
                  </b-form-invalid-feedback>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group form-group-sm">
                <label class="form-label">Поновите лозинку</label>
                <b-form-input id="repeatPassword" type="password" v-model="$v.form.repeatPassword.$model" :state="$v.form.repeatPassword.$dirty
                  ? !$v.form.repeatPassword.$error
                  : null
                  " class="form-control full-width">
                </b-form-input>
                <b-form-invalid-feedback class="error" v-if="!$v.form.repeatPassword.sameAsPassword">Лозинке морају бити
                  идентичне.</b-form-invalid-feedback>
              </div>
            </div>
          </div>
          <div class="spacer20"></div>
          <div class="d-md-flex justify-content-end align-items-center">
            <div class="form-group form-group-sm ">
              <button type="button" @click="update" class="btn btn-base-submit text-uppercase mr-3">
                Измена
              </button>
            </div>
          </div>
        </b-form>
        <div v-if="successMessage" class="pt-3">
          <b-alert show fade>{{ successMessage }}</b-alert>
        </div>
        <div v-if="errorMessage" class="pt-3">
          <b-alert show fade>{{ errorMessage }}</b-alert>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, minLength, sameAs, helpers  } from "vuelidate/lib/validators";

export default {
  name: "ResetPassPage",
  data() {
    return {
      form: {
        password: null,
        repeatPassword: null
      },

      successMessage: null,
      errorMessage: null,

      // axios
      baseApiUrl: window.env.VUE_APP_API_KCPROXY_DEV,
       
      meta: {
        title: "Правно-информациони систем РС",
        description:
          "Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.",
        keywords:
          "zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik"
      }
    };
  },
  metaInfo() {
    return {
      title: this.meta.title,
      meta: [
        { name: "title", content: this.meta.title },
        { name: "description", content: this.meta.description },
        { name: "keywords", content: this.meta.keywords }
      ]
    };
  },
  mixins: [validationMixin],
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(6),
        validCharacters: helpers.regex('validCharacters', /^[a-zA-Z0-9]*$/)
      },
      repeatPassword: {
        required,
        sameAsPassword: sameAs("password")
      }
    }
  },
  methods: {
    update() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else {
        axios
          .post(this.baseApiUrl + "proxy/changePassword", {
            password: this.form.password,
            repassword: this.form.repeatPassword
          })
          .then(response => {
            console.log(response);
            this.successMessage = "Изменили сте своју лозинку.";
          })
          .catch(error => {
            console.log(error);
            this.errorMessage = "Изменa лозинке није могућа.";
          });
      }
    }
  },
  beforeCreate: function () {
    document.body.className = "color_standard";
  }
};
</script>

<style scoped></style>
